import * as React from "react";
import { inject, observer } from "mobx-react";
import * as DocumentManagement from "../DocumentManagement";
import { PrivilegeMembership } from "../Shared";
import { NotificationStore } from "../Stores/NotificationStore";
import { CollectionStoreImpl } from "../Stores/CollectionStore";

interface IPrivilegeMembershipProps {
	groupId: string;
	collection: DocumentManagement.CollectionDetails;
	item: PrivilegeMembership;
	store?: CollectionStoreImpl;
}

@inject('store')
@observer
export class PrivilegeMembershipEdit extends React.Component<IPrivilegeMembershipProps, {}> {

	/* 
	* Getting Implicit Collection Privileges when the user clicks on any of the privilege memberships.
	* Seperated the logic for selected privilege and existing privileges. Because. we are merging the privileges only when the user clicks Save Button.
	*/
	handleChange = () => {
		NotificationStore.clearMessage();
		this.props.item.isExplicitMemberOf = !this.props.item.isExplicitMemberOf;
		this.props.store.updateImplicitPrivileges(this.props.collection);
	}

	render() {

		let inheritMember = this.props.item.isImplicitMemberOf && !this.props.item.isExplicitMemberOf ? "checkbox-style is--inherited" : "checkbox-style";

		return <td data-test-id={this.props.item.name} data-test-name="privilegeRadioCheck">
			<label className="custom-radiocheck">
				<input type="checkbox" checked={this.props.item.isExplicitMemberOf || this.props.item.isImplicitMemberOf} onChange={this.handleChange} />
				<span className={inheritMember}></span>
				<span className="checkbox-name">
					{this.props.item.name}
				</span>
			</label>
		</td>;
	}
}